<template>
    <div class="pay-succeed" :class="{'mobile-pay-succeed':isMobile}">
        <div class="box">
            <div class="result" v-if="order.orderStatus ==='0'">
                <p class="order">正在查询订单状态，请稍等{{countText}} ，若未出结果请点这里：
                    <a-button @click="orderDetail">这里</a-button>
                </p>
            </div>

            <div class="result" v-if="order.orderStatus ==='1'">
                <p class="icon">
                    <a-icon type="check-circle" />
                </p>
                <p style="font-size: 24px">支付成功</p>
              <p class="order">订单编号为：{{order.orderCode}}的订单已经支付成功，购买的{{order.productType==2?'商品':'课程'}}包括：{{order.remark}},共计 {{order.price}}
                元，赶快进行学习吧！</p>

                <p class="action">
                    <a-button type="primary" style="margin: 0 20px" @click="toHome">返回首页</a-button>
                    <a-button @click="toMyrCourse">我的课程</a-button>
                </p>
            </div>

            <div class="result" v-if="order.orderStatus !='0'&&order.orderStatus !='1'">
                <p class="icon">
                    <a-icon type="close-circle" />
                </p>
                <p style="font-size: 24px">支付失败</p>
                <p class="order">订单编号为：{{order.orderCode}} 的订单已经支付失败，原因：
                    <span v-if="order.orderStatus ==='2'"> 支付失败</span>
                    <span style="color:red" v-else-if="orderStatus==2">支付失败</span>
                    <span style="color:blue" v-else-if="orderStatus==3">已作废</span>
                    <span style="color:#108ee9" v-else-if="orderStatus==4">交易结束</span>
                    <span style="color:#2db7f5" v-else-if="orderStatus==6">交易超时</span>
                    <span style="color:cyan" v-else-if="orderStatus==7">等待付款</span>
                </p>
                <p class="action">
                    <a-button type="primary" style="margin: 0 20px" @click="toHome">返回首页</a-button>
                    <a-button @click="toMyCourse">我的课程</a-button>
                </p>
            </div>


        </div>
    </div>
</template>

<script>
    import {selectOrder} from "@api/shopping-api"
    import {showError} from "@utils/msg";
    import common from "../../mixin/common";
    import {DISPATCH_INIT_USER_INFO} from "@constants/action-type/login-action-type";

    export default {
        name: "PaySucceed",
        mixins: [common],
        data() {
            return {
                ordercode: "",
                succeedData: {},

                // 验证码倒计时
                show: false,
                count: 0,
                countText: "",

                // 订单详情
                order: {
                    orderStatus: "0"
                },
            }
        },

        created() {
            this.ordercode = this.$route.query.out_trade_no
            //   倒计时
            const TIME_COUNT = 6;
            if (!this.timer) {
                this.count = TIME_COUNT;
                this.show = false;
                this.timer = setInterval(() => {
                    //  根据ordercode  获取订单详情
                    selectOrder(this.ordercode).then((res) => {
                        if (res.order) {
                            this.order = res.order
                            this.$store.dispatch(DISPATCH_INIT_USER_INFO)
                        } else {
                            showError("获取订单出错", res.msg)
                        }
                    })

                    if (this.count > 0 && this.count <= TIME_COUNT) {
                        this.show = true;
                        this.count--;
                        this.countText = this.count + "s"
                    } else {
                        this.show = false;
                        clearInterval(this.timer);
                        this.timer = null;
                        this.countText = ""
                    }
                }, 1000)
            }
        },
        methods: {
            orderDetail() {
                //  根据ordercode  获取订单详情
                selectOrder(this.ordercode).then((res) => {
                    if (res.order) {
                        this.order = res.order
                    } else {
                        showError("获取订单出错", res.msg)
                    }
                })
            },

            toHome() {
                this.$router.push("/")
            },
            toMyrCourse() {
                this.$router.push("/other/personal/2")
            }
        }
    }
</script>

<style scoped lang="less">
    .pay-succeed {
        padding: 40px;

        .box {
            padding: 20px;
            background: white;

            p {
                margin: 20px;
                text-align: center;
            }

            .order {
                width: 850px;
                margin: auto;
                line-height: 26px;
                color: rgba(0, 0, 0, 0.45)
            }

            .icon {
                text-align: center;
                color: #52c41a;
                font-size: 72px;
                line-height: 72px;
                margin-bottom: 24px;
            }
        }
    }

    .result {
        min-height: calc(100vh - 240px);
    }

    // 移动端样式
    .mobile-pay-succeed {
        padding: 0;
        .box{
            width: 100%;
            .order{
                width: 100%;
            }
            .action{
            }
        }
    }
</style>
